// @flow

// Effect Managers
import { call, fork, select } from 'redux-saga/effects'

// Constants
import {
  LAYER_CATEGORY_HEFTY,
  LAYER_TYPE_COMPOSITION,
  SRC_TYPE_PNGBLOB,
} from '../constants'

// Sagas
import watchMapUpdates from './watchMapUpdates'
import handleMapCentering from './handleMapCentering'
import watchFarmSelected from './watchFarmSelected'
import watchSeasonSelected from './watchSeasonSelected'
import watchEditSelectedField from './editSelectedField'
import watchDeleteSelectedField from './deleteSelectedField'

// Selectors
import { firstAvailableGrowerId$ } from 'fc-assets'

// Controllers
import layersCtrl from 'hfty-ctrl-layers'
import assetsCtrl from 'fc-ctrl-assets'
import spatialCtrl from 'fc-ctrl-spatials'

export default function *main (): Generator<*, *, *> {
  yield call(layersCtrl.start)
  yield call(spatialCtrl.start)
  yield fork(watchMapUpdates)
  yield fork(handleMapCentering)
  yield fork(watchFarmSelected)
  yield fork(watchSeasonSelected)
  yield fork(watchEditSelectedField)
  yield fork(watchDeleteSelectedField)

  while (!(yield select(firstAvailableGrowerId$))) {
    yield call(assetsCtrl.when.received)
  }

  yield call(layersCtrl.read, {
    queryParams: {
      rootAsset: yield select(firstAvailableGrowerId$),
      category: LAYER_CATEGORY_HEFTY,
      layerType: LAYER_TYPE_COMPOSITION,
      srcType: SRC_TYPE_PNGBLOB,
    },
  })
}
